import React from "react";
import EiaLink from "../../components/tables/EiaLink";

//new season 8 aspects
export const delayedExtinction = <EiaLink name={"Aspect of Delayed Extinction"} link={"https://www.wowhead.com/diablo-4/affix/aspect-of-delayed-extinction-2192357"} isExternal={true} />;
export const impendingDeluge = <EiaLink name={"Aspect of Impending Deluge"} link={"https://www.wowhead.com/diablo-4/affix/aspect-of-impending-deluge-2241686"} isExternal={true} />;
export const serviceAndSacrifice = <EiaLink name={"Aspect of Service and Sacrifice"} link={"https://www.wowhead.com/diablo-4/affix/aspect-of-service-and-sacrifice-2239052"} isExternal={true} />;
export const contamination = <EiaLink name={"Aspect of Contamination"} link={"https://www.wowhead.com/diablo-4/affix/aspect-of-contamination-2246466"} isExternal={true} />;
export const shivering = <EiaLink name={"Shivering Aspect"} link={"https://www.wowhead.com/diablo-4/affix/shivering-aspect-2249121"} isExternal={true} />;
export const ripAndTear = <EiaLink name={"Rip and Tear Aspect"} link={"https://www.wowhead.com/diablo-4/affix/rip-and-tear-aspect-2208083"} isExternal={true} />;




